import { isArray } from "lodash";
import React from "react";
import PropTypes from "prop-types";
import DatePicker from "antd/lib/date-picker";
import { clientConfig } from "@/services/auth";
import { Moment } from "@/components/proptypes";
import qs from "query-string";

const { RangePicker } = DatePicker;

const DateRangeInput = React.forwardRef(({ defaultValue, value, onSelect, className, ...props }, ref) => {
  const currentUrlParams = qs.parse(window.location.search.substring(1));
  const datetype = currentUrlParams['p_datetype'];

  let format;
  const additionalAttributes = {};
  let pickerType; 

  // datetype 값에 따라 format 및 picker 옵션 동시에 설정
  switch (datetype) {
    case 'year':
      format = "YYYY";
      additionalAttributes.picker = 'year';
      pickerType = 'year';
      break;
    case 'month':
      format = "YYYY-MM";
      additionalAttributes.picker = 'month';
      pickerType = 'month';
      break;
    case 'day':
      format = "YYYY-MM-DD";
      additionalAttributes.picker = 'day';
      pickerType = 'month';
      break;
    default:
      format = clientConfig.dateFormat || "YYYY-MM-DD"; // 기본값
      pickerType = 'day'; // 기본값
  }

  if (isArray(defaultValue) && defaultValue[0].isValid() && defaultValue[1].isValid()) {
    additionalAttributes.defaultValue = defaultValue;
  }
  if (value === null || (isArray(value) && value[0].isValid() && value[1].isValid())) {
    additionalAttributes.value = value;
  }
  return (
    <RangePicker
      ref={ref}
      className={className}
      {...additionalAttributes}
      format={format}
      onChange={(newDates) => onSelect(newDates, pickerType)}
      {...props}
    />
  );
});

DateRangeInput.propTypes = {
  defaultValue: PropTypes.arrayOf(Moment),
  value: PropTypes.arrayOf(Moment),
  onSelect: PropTypes.func,
  className: PropTypes.string,
};

DateRangeInput.defaultProps = {
  defaultValue: null,
  value: undefined,
  onSelect: () => {},
  className: "",
};

export default DateRangeInput;
